export function PageHero({ eyebrow, title, subtitle, image, children }) {
  return (
    <section className="relative flex min-h-[56vh] items-end pb-14 pt-32" data-testid="page-hero">
      <div className="absolute inset-0">
        <img src={image} alt={title} className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C2C2C]/90 via-[#2C2C2C]/55 to-[#2C2C2C]/25" />
      </div>
      <div className="relative mx-auto w-full max-w-7xl px-5 lg:px-8 fade-up">
        {eyebrow && <p className="mb-4 text-sm uppercase tracking-[0.3em] text-[#C9A84C]">{eyebrow}</p>}
        <h1 className="max-w-3xl font-serif text-4xl font-500 leading-[1.08] text-white sm:text-5xl lg:text-6xl">{title}</h1>
        {subtitle && <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#FAF6EF]/85 lg:text-lg">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}

export function Eyebrow({ children }) {
  return <p className="mb-3 text-sm uppercase tracking-[0.25em] text-[#C9A84C]">{children}</p>;
}
